import { track } from "@plausible-analytics/tracker";

export type EventProps = Record<
  string,
  string | number | boolean | null | undefined
>;

const serialize = (
  props?: EventProps,
): Record<string, string> | undefined => {
  if (!props) return undefined;
  const out: Record<string, string> = {};
  for (const [key, value] of Object.entries(props)) {
    if (value === undefined || value === null || value === "") continue;
    out[key] = String(value);
  }
  return Object.keys(out).length === 0 ? undefined : out;
};

export const trackEvent = (name: string, props?: EventProps) => {
  if (!import.meta.env.PROD) return;
  try {
    track(name, { props: serialize(props) });
  } catch {
    // analytics must never break the app
  }
};
